import styled from 'styled-components';

export const MarqueeContainer = styled.div`
  background: ${(props) =>
   
       props.tabThemeSecondaryColor};
     
  padding: 8px 0;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  box-sizing: border-box;
  height: 32px;
  margin-top: 0px;
  .marquee {
    display: flex;
    white-space: nowrap;
    color: ${(props) =>   
       props.tabThemeColor};
    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;
    font-size: clamp(12px, 2vw, 14px);
    @media (min-width: 720px) {
      text-align: center;
      justify-content: center;
    }
  }

  .marquee-content {
    display: inline-flex;
    animation: scrollNew 10s linear infinite;

    ${(props) => {
      !props.lactoMama &&
        `@media (min-width: 720px) {
                        animation: none;
                        .hideForDesktop {
                            display: none;
                        }
                    }
            `;
    }}
  }

  .marquee-content span {
    padding-right: 12px; /* Space between the repeats */
  }
  @keyframes scrollNew {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-50%);
    }
  }
`;
